import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Seo } from "@/components/Seo";
import { PageHeader } from "@/components/common/PageHeader";
import { AppointmentCTA } from "@/components/sections/AppointmentCTA";
import { Reveal } from "@/components/common/Reveal";

const stageColor = { Problem: "#B45309", Diagnosis: "#0E7490", Treatment: "#0F5C5A", Outcome: "#0F766E" };

export default function PatientStories() {
  const [stories, setStories] = useState([]);
  useEffect(() => { api.get("/patient-stories").then((r) => setStories(r.data)).catch(() => {}); }, []);

  return (
    <>
      <Seo title="Patient Stories" description="Real patient journeys at CDT — from problem to diagnosis, treatment, and outcome." path="/patient-stories" />
      <PageHeader eyebrow="Patient Stories" title="Journeys, not just procedures" subtitle="Every story follows the same honest path: the problem, our diagnosis, the treatment, and the outcome." />

      <section className="py-14 lg:py-20" data-testid="patient-stories-timeline">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          {stories.map((s, idx) => (
            <Reveal key={s.id || idx}>
              <div className="rounded-[var(--cdt-radius-lg)] bg-white border border-[color:var(--cdt-border)] shadow-[var(--cdt-shadow-sm)] overflow-hidden">
                <div className="grid lg:grid-cols-[300px_1fr]">
                  <div className="h-56 lg:h-full"><img src={s.image} alt={s.title} loading="lazy" className="w-full h-full object-cover" /></div>
                  <div className="p-6 lg:p-8">
                    <h2 className="font-display text-2xl text-[var(--cdt-text)]">{s.title}</h2>
                    <p className="mt-2 text-sm text-[var(--cdt-muted)] leading-7">{s.summary}</p>
                    <div className="mt-6 space-y-4">
                      {s.timeline?.map((t, i) => (
                        <div key={i} className="flex gap-4">
                          <div className="flex flex-col items-center">
                            <span className="h-3 w-3 rounded-full mt-1.5" style={{ background: stageColor[t.stage] || "#0F5C5A" }} />
                            {i < s.timeline.length - 1 && <span className="flex-1 w-px bg-[color:var(--cdt-border)] mt-1" />}
                          </div>
                          <div className="pb-1">
                            <p className="text-xs font-semibold uppercase tracking-wide" style={{ color: stageColor[t.stage] || "#0F5C5A" }}>{t.stage}</p>
                            <p className="text-sm text-[var(--cdt-text)] leading-6 mt-0.5">{t.detail}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <AppointmentCTA />
    </>
  );
}
